import { AppService } from "@/service/app.service";
import {
    GET_MANNING_KEYS
} from "@/config/constants.config";

const state = {
    manningKeys: [
        { alias: 'veritas', id: 1},
        { alias: 'veritas1', id: 2},
    ]
};

const mutations = {
    SET_MANNING_KEYS: (state, manningKeys) => state.manningKeys = manningKeys
};

const actions = {

    async getManningKeys({ commit }) {
        commit('SET_MANNING_KEYS', []);
        let manningKeys = await AppService.submitPostData(GET_MANNING_KEYS, {});
        if(manningKeys) commit('SET_MANNING_KEYS', manningKeys);
    }

};

const getters = {
    manningKeys: state => AppService.capitalizeProperties(state.manningKeys)
};


export default {state, mutations, actions, getters};